import { Component } from '@angular/core';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-abi-graphs',
  templateUrl: './abi-graphs.component.html',
  styleUrls: ['./abi-graphs.component.css']
})
export class AbiGraphsComponent {
  abis: any[];
  selectedABI: any;

  tetData: any;
  roxData: any;
  famData: any;
  options: any;
  loading: boolean = true;

  constructor(private dataService: DataService){
    this.abis = [
      {name: "All", code: "All"}
    ]
    this.selectedABI = this.abis[0];
  }

  ngOnInit() {
    this.populateABINames();
    this.populateGraphs(this.abis[0].code);
    this.options = {
      maintainAspectRatio: false,
      aspectRatio: .4,
      showLine: false,
      plugins: {
        legend: {
          display: false
        }
      }
    };
  }

  populateGraphs(abiName: string){
    this.loading = true;
    this.dataService.getABIGraphs(abiName).then(data => {
      this.tetData = data[0];
      this.roxData = data[1];
      this.famData = data[2];
      this.loading = false;
    });
  }

  populateABINames(){
    this.dataService.getABINames().then(data => {
      data.map(y => this.abis.push({name: y, code: y}))
    });
  }
}
